import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { Authenticator, ThemeProvider, defaultDarkModeOverride } from '@aws-amplify/ui-react'
import '@aws-amplify/ui-react/styles.css'
import './index.css'
import { authConfigured, configureAmplify, APP_PATH } from './amplify'
import { startLiveUpdates } from './lib/liveUpdate'
import Landing from './pages/Landing'
import RaceStudio from './pages/RaceStudio'
import Account from './pages/Account'
import Privacy from './pages/Privacy'
import Support from './pages/Support'

configureAmplify()
// iOS app: confirm this bundle booted and fetch a newer one from the site when there is one.
// It switches immediately only on the home page, where there is nothing to lose.
startLiveUpdates(() => window.location.pathname === '/')

const router = createBrowserRouter([
  { path: '/', element: <Landing /> },
  { path: '/account', element: <Account /> },
  { path: '/privacy', element: <Privacy /> },
  { path: '/support', element: <Support /> },
  { path: `${APP_PATH}/*`, element: <RaceStudio /> },
])

const app = <RouterProvider router={router} />
// The sign-in widget follows the app's dark palette.
const theme = { name: 'mala-dark', overrides: [defaultDarkModeOverride] }

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {authConfigured ? (
      <ThemeProvider theme={theme} colorMode="dark">
        <Authenticator.Provider>{app}</Authenticator.Provider>
      </ThemeProvider>
    ) : (
      app
    )}
  </StrictMode>,
)
